import parse from 'html-react-parser'
import { useState } from 'react'
import { createClient } from 'graphqurl'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Image from 'react-bootstrap/Image'
import Modal from 'react-bootstrap/Modal'
import Badge from 'react-bootstrap/Badge'
import Card from 'react-bootstrap/Card'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShare } from '@fortawesome/free-solid-svg-icons'

import styles from '../../styles/JobPoster.module.scss'
import ShareButton from '../ShareButton' 

interface PosterProps {
	poster: any
	preferredLang?: string
	renderShare?: boolean
	viewedPosters?: any
	setViewedPosters?: any
}

const Poster: React.FC<PosterProps> = ({ poster, preferredLang, renderShare, viewedPosters, setViewedPosters }) => {
	const { id, imageUrl, description, imageUrlChinese, descriptionChinese, MrtStation, contact, Company } = poster

	const [show, setShow] = useState(false)
	const [showShare, setShowShare] = useState(false)

	const { t } = useTranslation()

	const router = useRouter()
	const { uuid } = router.query

	const getHTML = () => {
		if (preferredLang !== undefined) {
			if (description !== null) return description
			else return descriptionChinese
		} else {
			if (preferredLang === 'EN') {
				if (description !== null) return description
				else return descriptionChinese
			} else {
				if (descriptionChinese !== null) return descriptionChinese
				else return description
			}
		}
	}

	const getImgURL = () => {
		if (preferredLang !== undefined) {
			if (imageUrl !== null) return imageUrl
			else return imageUrlChinese
		} else {
			if (preferredLang === 'EN') {
				if (imageUrl !== null) return imageUrl
				else return imageUrlChinese
			} else {
				if (imageUrlChinese !== null) return imageUrlChinese
				else return imageUrl
			}
		}
	}
	
	// insert row
	const insertView = () => {
		const object: { id?: number, jobPoster: number, count: number, kioskSource: null, sourceType: string, saveJobs: any } = {
			jobPoster: id,
			count: 1,
			kioskSource: null,
			sourceType: 'WEB_FINDJOBS',
			saveJobs: typeof uuid === 'undefined' ? null : uuid
		}

		const client = createClient({
			endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string
		})

		client.query({
			query: `
				mutation ($object: JobPoster_Job_View_insert_input!) {
					insert_JobPoster_Job_View_one(
						object: $object
						# on_conflict: {
						# 	constraint: JobPoster_Job_View_pkey
						# 	update_columns: [count]
						# }
					) {
						id
					}
				}
			`,
			variables: { object }
		})
			.catch(err => console.error(err))
	}

	// inc count
	const incView = () => {
		const incrementMutation = `
			mutation ($id: Int! $uuid: uuid) {
				update_JobPoster_Job_View(where: {
					jobPoster: {_eq: $id}
					sourceType: {_eq: WEB_FINDJOBS}
					${typeof uuid !== 'undefined' ? 'saveJobs: {_eq: $uuid}' : 'saveJobs: {_is_null: true}'}
				} _inc: { count: 1}) {
					affected_rows
				}
			}
		`
		
		const clientSecondInstance = createClient({
			endpoint: process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT as string
		})

		if (router.pathname !== '/job-basket/saved/[uuid]') {
			const isIncluded = viewedPosters.some(ele => ele.id === poster.id)
			
			if (!isIncluded) {
				setViewedPosters([...viewedPosters, poster])
				window.localStorage.setItem('viewed-posters', JSON.stringify([...viewedPosters, poster]))
			}
		}

		clientSecondInstance.query({
			query: incrementMutation,
			variables: { id, uuid }
		})
			.then(res => {
				if (res?.data?.update_JobPoster_Job_View?.affected_rows === 0) {
					// run insert
					insertView()
				}
			})
			.catch(err => {
				console.error(err)
			})
	}

	return (
		<>
			{/* <Col lg='4' md='6' xs='12' className='mb-4'> */}
			<Col
				lg={typeof router.query.id !== 'undefined' ? '6' : '4'}
				md={typeof router.query.id !== 'undefined' ? '12' : '6'}
				xs='12'
				className={`mb-4 ${typeof router.query.id !== 'undefined' ? 'mx-auto' : ''}`}
			>
				<Card
					className={styles.card}
					onClick={() => {
						// if client is on list page
						if (typeof router.query.id === 'undefined') {
							setShow(true)
							incView()
						}
					}}
				>
					<Card.Body>
						{renderShare && (
							<>
								<div className='text-end'>
									<Button variant='link' onClick={() => { setShowShare(true) }} className='text-decoration-none'>
										<FontAwesomeIcon icon={faShare} />&nbsp;Share
									</Button>
								</div>
								<hr />
							</>
						)}

						<div className='d-flex justify-content-between align-items-center p-3'>
							<p
								className={styles.paragraph}
							>{Company.name}</p>
							{Company.avatar !== null && <Image width={35} height={35} src={Company.avatar} alt='' className={styles.coImage} />}
						</div>
						{/* Prefer to display Graphic */}
						{(imageUrl !== null || imageUrlChinese !== null) ? (
							<Image
								src={getImgURL()}
								alt='Job Poster'
								className='w-100'
							/>
						) : (
							<div className={typeof router.query.id !== 'undefined' ? styles.htmlContainerModal : styles.htmlContainer}>
								{parse(getHTML())}
							</div>
						)}

						{typeof router.query.id !== 'undefined' ? (
							<>
								<p className='mt-5 text-center'>
									{MrtStation === null ? 'Multiple locations' : (
										<span>
											<Badge
												ref={ele => {
													if (ele) ele.style.setProperty('background-color', MrtStation.MrtLine.colour, 'important')
												}}
											>
												{MrtStation.id}
											</Badge>
											{MrtStation.name}
										</span>
									)}	
								</p>

								<p className='text-center'>
									<span className={styles.paragraph}>Contact Info</span><br />
									<a href={`tel:${contact}`}>
										{contact}
										<Image
											src='/img/poster/click-me.gif' alt='Click here'
											width={25} height={25}
											// style={{ position: 'relative', right: '5px', top: '10px' }}
											className={styles.gif}
										/>
									</a>
								</p>
							</>
						) : (
							<div className='p-3'>
								<Button
									className={styles.button}
								>Call Now</Button>
							</div>
						)}

					</Card.Body>
				</Card>
			</Col>
			<Modal show={show} onHide={() => setShow(false)}>
				<Modal.Header closeButton>
					<Button
						variant='link'
						onClick={() => {
							setShow(false)
							setShowShare(true)
						}}
						className='text-decoration-none p-0'
					>
						<FontAwesomeIcon icon={faShare} />&nbsp;Share
					</Button>
				</Modal.Header>
				<Modal.Body className='p-0'>
					<div className='d-flex justify-content-between align-items-center p-3'>
						<p className={styles.paragraph}>{Company.name}</p>
						{Company.avatar !== null && <Image width={35} height={35} src={Company.avatar} alt='' className={styles.coImage} />}
					</div>

					{imageUrl !== null || imageUrlChinese !== null ? (
						<Image
							src={getImgURL()}
							alt='Job Poster'
							className='w-100'
						/>
					) : (
						<div className={styles.htmlContainerModal}>
							{parse(getHTML())}
						</div>
					)}

					<p className='mt-5 text-center'>
						{MrtStation === null ? 'Multiple locations' : (
							<span>
								<Badge
									ref={ele => {
										if (ele) ele.style.setProperty('background-color', MrtStation.MrtLine.colour, 'important')
									}}
								>
									{MrtStation.id}
								</Badge>
								{MrtStation.name}
							</span>
						)}	
					</p>

					<p className='text-center'>
						<span className={styles.paragraph}>Contact Info</span><br />
						<a href={`tel:${contact}`}>
							{contact}
							<Image
								src='/img/poster/click-me.gif' alt='Click here'
								width={25} height={25}
								// style={{ position: 'relative', right: '5px', top: '10px' }}
								className={styles.gif}
							/>
						</a>
					</p>
				</Modal.Body>
			</Modal>
			<Modal show={showShare} onHide={() => { setShowShare(false) }} size='lg'>
				<Modal.Body className='text-center'>
					<p className='fw-bolder mt-3'>{t('job_list.Share_this_job_with_your_friends')}</p>
					<div className={styles.shareBtn} >
						<ShareButton url={`${process.env.NEXT_PUBLIC_DOMAIN}/job-posters/${id}`} />
					</div>
					<br />
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Poster
